import type { RequestOptions } from 'owa-service/lib/RequestOptions';
import { getHeaders } from 'owa-headers';

export default function getRequestOptions(targetMailbox: string): RequestOptions | undefined {
    return targetMailbox ? { headers: getHeaders(targetMailbox) } : undefined;
}
